import { useState } from "react";
import MenuContext from "./menu-context";

const defaultContextValue = {
    index: 0,
    scrollEnabled: true,
}

const MenuContextProvider = (props) => {

    const [menuState, setMenuState] = useState(defaultContextValue);

    const updateMenuState = (index, scrollEnabled) => {
        setMenuState({ index, scrollEnabled });
    }

    const menuContext = {
        index: menuState.index,
        updateContext: updateMenuState,
        scrollEnabled: menuState.scrollEnabled,
    }

    return (
        <MenuContext.Provider value={menuContext}>
            {props.children}
        </MenuContext.Provider>
    );

}

export default MenuContextProvider;
